import { z } from 'zod';

export const SystemInfoSchema = z.object({
  hostname: z.string(),
  platform: z.string(),
  arch: z.string(),
  nodeVersion: z.string(),
  pm2Version: z.string(),
  cpuCount: z.number(),
  cpuModel: z.string(),
  /** 1/5/15-minute load averages. */
  loadavg: z.tuple([z.number(), z.number(), z.number()]),
  totalMemory: z.number(),
  freeMemory: z.number(),
  /** Seconds since boot. */
  uptime: z.number(),
  /** Epoch ms the bridge process itself started. */
  bridgeStartedAt: z.number(),
  bridgeVersion: z.string(),
});
export type SystemInfo = z.infer<typeof SystemInfoSchema>;

/**
 * One point in the rolling metrics buffer. Server-aggregate samples use
 * processId `null`; per-process samples carry the pm2 id.
 */
export const MetricSampleSchema = z.object({
  timestamp: z.number(),
  processId: z.number().nullable(),
  cpu: z.number(),
  memory: z.number(),
});
export type MetricSample = z.infer<typeof MetricSampleSchema>;

export const MetricsHistorySchema = z.object({
  windowSeconds: z.number(),
  server: z.array(MetricSampleSchema),
  byProcess: z.record(z.array(MetricSampleSchema)),
});
export type MetricsHistory = z.infer<typeof MetricsHistorySchema>;
